<template>
  <div class="basic">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      class="demo-ruleForm"
      label-width="145px"
    >
      <div style="display: flex">
        <div class="left-basic">
          <el-form-item
            label="照片"
            prop="imageUrl"
            style="margin-bottom: 30px"
          >
            <el-upload
              :auto-upload="false"
              :on-change="onChangeImgCopy"
              :show-file-list="false"
              accept="image/*"
              action="#"
              class="avatar-uploader"
            >
              <div style="display: flex; position: relative; margin-left: 8px">
                <img
                  v-if="ruleForm.imageUrl"
                  :src="ruleForm.imageUrl"
                  class="avatar"
                />
                <div class="file">
                  <i
                    class="el-icon-zoom-in"
                    @click.stop="handlePictureCardPreview(ruleForm.imageUrl)"
                  ></i>
                  <i
                    class="el-icon-download"
                    @click.stop="handleDownload(ruleForm.imageUrl)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="handleRemove(ruleForm.imageUrl)"
                  ></i>
                </div>
              </div>
              <i
                v-if="!ruleForm.imageUrl"
                class="el-icon-plus avatar-uploader-icon"
                style="margin-left: 8px"
              ></i>
            </el-upload>
            <div class="annotations" style="line-height: 1">
              请上传JPG/PNG格式的尺寸为128px:173px的蓝底照片
            </div>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.photo != formerList.photo
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>

          <el-form-item
            class="w"
            label="工作照"
            prop="jobImg"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-upload
              :auto-upload="false"
              :on-change="onChangeImgCopyjobImg"
              :show-file-list="false"
              accept="image/*"
              action="#"
              class="avatar-uploader"
              style="display: flex; margin-bottom: 10px; z-index: 999"
            >
              <div
                v-for="(items, ind) in ruleForm.jobImg"
                :key="ind"
                style="display: flex; position: relative; margin-left: 8px"
                @click.stop
              >

                <img :src="items" class="avatar" />
                <div class="file">
                  <i
                    class="el-icon-zoom-in"
                    @click="handlePictureCardPreviewjobImg(items)"
                  ></i>

                  <i
                    class="el-icon-download"
                    @click="handleDownloadjobImg(items)"
                  ></i>

                  <i
                    class="el-icon-delete"
                    @click="handleRemovejobImg(ind)"
                  ></i>
                </div>
              </div>

              <i
                v-if="ruleForm.jobImg ? ruleForm.jobImg.length < 3 : 'false'"
                class="el-icon-plus avatar-uploader-icon"
                style="margin-left: 8px"
              ></i>
            </el-upload>
            <div
              class="annotations"
              style="white-space: nowrap; line-height: 1.5"
            >
              请上传三张JPG/PNG格式的尺寸为278px:186px的照片
            </div>
          </el-form-item>

          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.username != formerList.username
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.sex != formerList.sex
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="ruleForm.birthday"
              format="yyyy 年 MM 月 dd 日"
              placeholder="选择日期"
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.birth != formerList.birth
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>
          <!-- <el-form-item label="手机号码" prop="phone">
                      <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item> -->
        </div>
        <div class="right-basic">
          <el-form-item label="籍贯" prop="place">
            <el-input v-model="ruleForm.place"></el-input>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.native_place != formerList.native_place
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>
          <el-form-item label="政治面貌" prop="outlook">
            <el-select
              v-model="ruleForm.outlook"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="中共党员" value="中共党员"></el-option>
              <el-option label="民主党派" value="民主党派"></el-option>
              <el-option label="无党派" value="无党派"></el-option>
              <el-option label="群众" value="群众"></el-option>
            </el-select>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.outlook != formerList.outlook
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
          </el-form-item>

          <el-form-item label="单位及职务" prop="belonging">
            <el-input v-model="ruleForm.belonging"></el-input>
            <i
              v-if="
                !isRed
                  ? false
                  : formerList
                  ? currentList.position != formerList.position
                  : false
              "
              class="el-icon-s-opportunity red"
            ></i>
            <span
              style="
                position: absolute;
                left: 0;
                top: 40px;
                color: rgba(0, 0, 0, 0.45);
                font-size: 12px;
              "
            >
              请填写个人职务，无须填写所在检察院
            </span>
          </el-form-item>
        </div>
      </div>
      <el-form-item
        label="个人简介"
        prop="tinymceHtml"
        style="margin-top: 30px"
      >
        <el-input
          v-model="ruleForm.tinymceHtml"
          :rows="10"
          maxlength="300"
          placeholder="请输入内容"
          show-word-limit
          style="width: 80%; float: left; margin-right: 50px"
          type="textarea"
        >
        </el-input>
        <span class="example" @click="openExamole">示例</span>

        <!-- <ueditor v-model="ruleForm.tinymceHtml"></ueditor> -->
        <i
          v-if="
            !isRed
              ? false
              : formerList
              ? currentList.introduction != formerList.introduction
              : false
          "
          class="el-icon-s-opportunity red"
        ></i>
      </el-form-item>
      <el-button
        ref="rongyu"
        class="btn"
        type="primary"
        @click="submitForm('ruleForm')"
        >下一页
      </el-button>
    </el-form>

    <el-dialog :visible.sync="dialogVisible">
      <img :src="dialogImageUrl" alt="" width="100%" />
    </el-dialog>
    <!-- 示例 -->
    <el-dialog
      :visible.sync="exampleVisible"
      center
      title="个人简介参考模板"
      width="30%"
    >
      <span
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王某某，女，1986年2月出生，中共党员，现任某某市人民检察院第八检察部主任，一级检察官。从检14年来，她敢于担当、公正司法，积极推进未成年人司法保护工作，所办案件入选全国检察机关依法维护妇女儿童权益十大案例。创建“强制报告”平台，使在校生被侵害犯罪率下降15%。创立“1+7+N”联动留守儿童保护机制，实现留守儿童犯罪和被犯罪率“双下降”。担任央视、最高检《守护明天》节目主讲人，被央视聘为“公益普法人”。其先进事迹被《中国青年报》《检察日报》《新华日报》等媒体报道。先后被授予全国先进工作者、全国巾帼建功标兵、全国维护妇女儿童权益先进个人、全省“人民满意的公务员”、江苏最美法治人物等荣誉。<br />
        <br /><span style="font-weight: bold">说明</span
        >：个人简介由三个部分组成，250—300字（不少于250字，不多于300字）。
        <br />
        1.个人基本情况（姓名、性别、出生日期、政治面貌、任职单位部门及职务、职级）。
        <br />
        2.检察工作主要业绩、贡献度及社会影响（媒体报道）。 <br />
        3.所获主要荣誉（不必面面俱到，写有影响的重要荣誉3—5项即可）。
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ueditor from "@/components/editor";
import { isphone } from "@/filters";
import { mapGetters } from "vuex";

export default {
  components: { ueditor },
  props: ["firstList"],
  computed: { ...mapGetters(["userInfo"]) },
  data() {
    let validateInput = (rule, value, callback) => {
      // console.log(value.indexOf("http:"));
      if (value.length < 250) {
        callback(new Error("个人简介字数限制为250-300字之间"));
      } else {
        callback();
      }
    };
    let validateInput2 = (rule, value, callback) => {
      // console.log(value.indexOf("http:"));
      if (value.length < 3) {
        callback(new Error("工作照必须三张"));
      } else {
        callback();
      }
    };
    return {
      // 示例
      exampleVisible: false,

      dialogImageUrl: "",
      dialogVisible: false,
      imageUrl: false,
      editorShow: true,
      editorInit: {
        language_url: "/static/tinymce/zh_CN.js",
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/lightgray",
        height: 300,
      },
      currentList: [], //倒数第一次数据
      formerList: null, //倒数第二次数据
      ruleForm: {
        name: "",
        sex: "",
        birthday: "",
        phone: "",
        place: "",
        jobImg: [],
        imageUrl: "",
        outlook: "", //面貌
        belonging: "", //所属
        tinymceHtml: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "chang" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        phone: isphone(),
        place: [{ required: true, message: "请输入籍贯", trigger: "blur" }],
        imageUrl: [{ required: true, message: "请上传照片", trigger: "blur" }],
        jobImg: [
          { required: true, message: "请上传照片", trigger: "blur" },
          { validator: validateInput2, trigger: "blur" },
        ],
        outlook: [{ required: true, message: "请选择面貌", trigger: "blur" }],
        belonging: [
          {
            required: true,
            message: "请输入所属检察院(部职别)",
            trigger: "blur",
          },
        ],
        tinymceHtml: [
          {
            required: true,
            message: "个人简介字数限制为250-300字之间",
            trigger: "blur",
          },
          { validator: validateInput, trigger: "blur" },
        ],
      },
      options: [],
      isRed: false, //是否显示标红
    };
  },
  methods: {
    //示例
    openExamole() {
      this.exampleVisible = true;
    },

    onChangeImgCopy(file) {
      // console.log(file);
      this.uploadImgToOss(file)
        .then((res) => {
          if (res.status == 200) {
            this.ruleForm.imageUrl = this.ossUrl + res.data.data;
          }
        })
        .catch((error) => {});
    },
    handlePictureCardPreview(file) {
      // console.log(file);
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    handleRemove(index) {
      this.ruleForm.imageUrl = "";
    },
    handleDownload(file) {
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = file;
      a.target = "_blank";
      a.click();
    },
    //
    onChangeImgCopyjobImg(file) {
      // console.log(file);
      if (this.ruleForm.jobImg) {
        if (this.ruleForm.jobImg.length >= 3) {
          this.$message.error("最多上传3张");
          return;
        }
      }
      this.uploadImgToOss(file)
        .then((res) => {
          if (res.status == 200) {
            // console.log(this.ruleForm.jobImg);
            // console.log(this.ossUrl + res.data.data);
            this.ruleForm.jobImg.push(this.ossUrl + res.data.data);
          }
        })
        .catch((error) => {});
    },
    handlePictureCardPreviewjobImg(file) {
      // console.log(file);
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    handleRemovejobImg(ind) {
      // console.log(ind);
      // console.log(this.ruleForm.jobImg);
      this.ruleForm.jobImg.splice(ind, 1);
    },
    handleDownloadjobImg(file) {
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = file;
      a.target = "_blank";
      a.click();
    },
    // 平台logo上传
    // onChangeImg(file) {
    //   this.uploadImgToOss(file)
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data.code == 200) {
    //         this.ruleForm.imageUrl = this.ossUrl + res.data.data;
    //         this.imageUrl = true;
    //         console.log(this.ruleForm.imageUrl);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    submitForm(formName) {
      // console.log(this.ruleForm);

      this.$refs[formName].validate((valid) => {
        if (this.ruleForm.tinymceHtml.length < 250) {
        }

        if (valid) {
          // alert("submit!");
          this.$emit("basicList", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subClick() {
      this.ruleForm.tinymceHtml = this.$refs.tinymce.myValue;
      this.$refs.rongyu.$el.click();
    },
    getFormerListList(val) {
      // console.log(val);
      this.formerList = val;
    },
    getCurrentList(val) {
      // console.log(val.job_photo);
      this.currentList = val;
      this.ruleForm.name = val.username;
      this.ruleForm.sex = val.sex ? String(val.sex) : "1";
      this.ruleForm.birthday = val.birth; //
      this.ruleForm.phone = val.phone;
      // this.ruleForm.jobImg =
      //   val.job_photo == null ? [] : localStorage.getItem("jobImg");
          this.ruleForm.jobImg =
        val.job_photo == null||val.job_photo == "" ? [] :JSON.parse(val.job_photo) ;
      this.ruleForm.place = val.native_place;
      if (val.photo == "" || val.photo == null) {
        this.imageUrl = false;
      } else {
        this.imageUrl = true;
      }
      this.ruleForm.imageUrl = val.photo; //
      this.ruleForm.outlook = val.outlook;
      this.ruleForm.belonging = val.position;
      this.ruleForm.tinymceHtml =
        val.introduction == null ? "" : val.introduction;
      // console.log(this.ruleForm.jobImg);
    },
  },

  mounted() {
    // getAllRegion().then((res) => {
    //   if (res.code == 200) {
    //     this.options = res.data;
    //   }
    // });
    if (this.$route.path == "/taggingManage/look-advanced") {
      this.isRed = true;
    }
    console.log(this.userInfo);
  },
  watch: {
    firstList(val) {
      this.ruleForm = Object.assign({}, val);
    },
  },
  // activated(){
  //   this.ruleForm =  this.list
  // },
};
</script>

<style lang="scss" scoped>
//示例
.example {
  float: left;
  cursor: pointer;
  font-size: 18px;
}

.btn {
  position: fixed;
  bottom: 30px;
  right: 60px;
  background-color: transparent;
  color: #999 !important;
}

.red {
  font-size: 16px;
  color: red;
  margin-left: 10px;
  position: absolute;
  right: 15%;
  top: 50%;
  transform: translate(0%, -50%);
}

.basic {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  padding: 20px 0px;

  .left-basic {
    width: 40%;
  }

  .right-basic {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
}

/deep/ .el-input__inner {
  height: 36px;
  width: 80%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 83px;
  height: 83px;
  display: block;
}

.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

/deep/ .el-input__suffix {
  right: 20%;
}

/deep/ .el-form-item {
  margin-bottom: 15px;
}

#tinymce {
  width: 80%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-popper {
  min-width: 400px !important;
  height: 300px;
  overflow: auto;
}

.editor {
  width: 80% !important;
  margin: 0 !important;
}

.file {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: #000;
  opacity: 0;
  // border-radius: 50%;
  i {
    color: #fff;
    margin-right: 5px;
    margin-left: 5px;
  }
}

.file:hover {
  opacity: 0.5;
}

.w /deep/ .el-upload {
  display: flex;
}

/deep/ .el-dialog__header {
  border-bottom: none;
}

/deep/ .el-dialog {
  margin-top: 50vh !important;
  transform: translate(0vh, -50%);
}
</style>
